const carRental = {
  carRental: "Ενοικίαση αυτοκινήτων", // translated
  carRentals: "Ενοικιάσεις Αυτοκινήτων", // translated
  pickUpPoint: "Σημείο παραλαβής", // translated
  dropOffPoint: "Σημείο πτώσης", // translated
  pickUpDate: "Ημερομηνία Παραλαβής", // translated
  dropOffDate: "Ημερομηνία αποχώρησης", // translated
  pickUp: "Μαζεύω", // translated
  dropOff: "Αποβίβαση", // translated
  edit: "Επεξεργασία", // translated
  fuelPolicy: "Πολιτική καυσίμων", // translated
  pickUpLocation: "Τοποθεσία παραλαβής", // translated
  mileage: "Απόσταση σε μίλια", // translated
  transmission: "Μετάδοση", // translated
  airCondition: "Κλιματιστικό", // translated
  minimumAge: "Ελάχιστη ηλικία", // translated
  maximumAge: "Μέγιστη Ηλικία", // translated
  providerAddress: "Διεύθυνση παρόχου", // translated
  providerPhone: "Τηλέφωνο παρόχου", // translated
  driverInfo: "Πληροφορίες προγράμματος οδήγησης", // translated
  driversInfo: "Πληροφορίες οδηγού", // translated
  differentDropOff: "Παράδοση σε διαφορετική τοποθεσία", // translated
  maxPassengers: "Max Passengers", // translated
  budget: "Προϋπολογισμός", // translated
  provider: "Προμηθευτής", // translated
  carModel: "Μοντέλο αυτοκινήτου", // translated
  numOfDoors: "Αριθμός θυρών", // translated
  fuelType: "Τύπος καυσίμου", // translated
  driverAge: "Ηλικία οδηγού", // translated
  workingHours: "Ωρες εργασίας", // translated
  driverNationality: "Εθνικότητα οδηγού", // translated
  carRentalRate: "Τιμή ενοικίασης αυτοκινήτου", // translated
  dueNow: "Λήγει τώρα", // translated
  duePickUp: "Οφείλεται κατά την παραλαβή", // translated
  toViewOfferPDF: "Για να δείτε ένα έγγραφο PDF που περιέχει όλους τους όρους ενοικίασης αυτής της προσφοράς, παρακαλούμε", // translated
  toViewTermsAndCondPDF: "Για να δείτε τους ισχύοντες Όρους και Προϋποθέσεις του CARNECT, παρακαλούμε", // translated
};


export default carRental;
